import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Directive({
    selector: '[tooltip]',
    standalone: true
})
export class TooltipDirective implements OnInit, OnDestroy {
  @Input() tooltip: string|(()=>string) = '';
  @Input('tooltipPlacement') placement: 'top'|'bottom'|'left'|'right' = 'top';

  private ref: any;

  constructor(private readonly elementRef: ElementRef) {
  }

  ngOnInit() {
    const bootstrap = (window as any)['bootstrap'];
    if(bootstrap) {
      const title = typeof this.tooltip === 'function' ? this.tooltip : () => this.tooltip;
      this.ref = new bootstrap.Tooltip(this.elementRef.nativeElement, {title, placement: this.placement, trigger: 'hover', html: true, customClass: 'user-select-none'});
    }
  }

  ngOnDestroy() {
    if(this.ref) {
      this.ref.hide();
      setTimeout(()=>{
        try {
          this.ref?.dispose();
        } catch {}
      }, 2000);
    }
  }
}
